import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { addPackageJSONIfNeeded } from "@codesandbox/sandpack-client";
import { SANDBOX_TEMPLATES } from "../templates";
export var getSandpackStateFromProps = function getSandpackStateFromProps(props) {
  var _a, _b; // Merge predefined template with custom setup


  var projectSetup = getSetup(props.template, props.customSetup); // openPaths and activePath override the setup flags

  var openPaths = (_a = props.openPaths) !== null && _a !== void 0 ? _a : [];
  var activePath = props.activePath;

  if (openPaths.length === 0 && ((_b = props.customSetup) === null || _b === void 0 ? void 0 : _b.files)) {
    var inputFiles = props.customSetup.files; // extract open and active files from the custom input files

    Object.keys(inputFiles).forEach(function (filePath) {
      var file = inputFiles[filePath];

      if (typeof file === "string") {
        openPaths.push(filePath);
        return;
      }

      if (!activePath && file.active) {
        activePath = filePath;

        if (file.hidden === true) {
          openPaths.push(filePath); // active file needs to be available even if someone sets it as hidden by accident
        }
      }

      if (!file.hidden) {
        openPaths.push(filePath);
      }
    });
  }

  if (openPaths.length === 0) {
    // If no files are received, use the project setup / template
    openPaths = Object.keys(projectSetup.files);
  } // If no activePath is specified, use the first open file


  if (!activePath) {
    activePath = projectSetup.main || openPaths[0];
  } // If for whatever reason the active path was not set as open, set it


  if (!openPaths.includes(activePath)) {
    openPaths.push(activePath);
  }

  if (!projectSetup.files[activePath]) {
    throw new Error("".concat(activePath, " was set as the active file but was not provided"));
  }

  var files = addPackageJSONIfNeeded(projectSetup.files, projectSetup.dependencies || {}, projectSetup.entry);
  var environment = projectSetup.environment;
  return {
    openPaths: openPaths,
    activePath: activePath,
    files: files,
    environment: environment
  };
}; // The template is predefined (eg: react, vue, vanilla)
// The setup can overwrite anything from the template (eg: files, dependencies, environment, etc.)

export var getSetup = function getSetup(template, inputSetup) {
  // The input setup might have files in the simple form Record<string, string>
  // so we convert them to the sandbox template format
  var setup = createSetupFromUserInput(inputSetup);

  if (!template) {
    // If not input, default to vanilla
    if (!setup) {
      return SANDBOX_TEMPLATES.vanilla;
    }

    if (!setup.files || Object.keys(setup.files).length === 0) {
      throw new Error("When using the customSetup without a template, you must pass at least one file for sandpack to work");
    } // If not template specified, use the setup entirely


    return setup;
  }

  var baseTemplate = SANDBOX_TEMPLATES[template];

  if (!baseTemplate) {
    throw new Error("Invalid template '".concat(template, "' provided."));
  } // If no setup, the template is used entirely


  if (!setup) {
    return baseTemplate;
  } // Merge the setup on top of the template


  return {
    files: _objectSpread(_objectSpread({}, baseTemplate.files), setup.files),
    dependencies: _objectSpread(_objectSpread({}, baseTemplate.dependencies), setup.dependencies),
    entry: setup.entry || baseTemplate.entry,
    main: setup.main || baseTemplate.main,
    environment: setup.environment || baseTemplate.environment
  };
};

var createSetupFromUserInput = function createSetupFromUserInput(setup) {
  if (!setup) {
    return null;
  }

  if (!setup.files) {
    return setup;
  }

  var files = setup.files;
  var convertedFiles = Object.keys(files).reduce(function (acc, key) {
    if (typeof files[key] === "string") {
      acc[key] = {
        code: files[key]
      };
    } else {
      acc[key] = files[key];
    }

    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, setup), {}, {
    files: convertedFiles
  });
};